module.exports = __webpack_public_path__ + "static/media/manual.c1ca8ff2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/manual.svg
// module id = 286
// module chunks = 0